import type { SVGProps } from "react";

export function DiscordIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      fill="currentColor"
      aria-hidden="true"
      {...props}
    >
      <path d="M20.317 4.369A19.79 19.79 0 0 0 15.432 3c-.21.375-.45.88-.616 1.28a18.27 18.27 0 0 0-5.632 0A12.6 12.6 0 0 0 8.562 3 19.74 19.74 0 0 0 3.677 4.37C.574 8.94-.32 13.39.116 17.78a19.9 19.9 0 0 0 6.012 3.03c.485-.663.918-1.368 1.29-2.108a12.9 12.9 0 0 1-2.03-.98c.17-.124.336-.253.497-.386a14.2 14.2 0 0 0 12.228 0c.163.135.329.264.497.386-.65.384-1.33.713-2.033.98.372.74.805 1.445 1.29 2.108a19.86 19.86 0 0 0 6.015-3.03c.5-5.09-.838-9.5-3.565-13.41ZM8.02 15.09c-1.183 0-2.157-1.085-2.157-2.42 0-1.334.955-2.42 2.157-2.42 1.21 0 2.176 1.095 2.156 2.42 0 1.335-.955 2.42-2.156 2.42Zm7.96 0c-1.183 0-2.157-1.085-2.157-2.42 0-1.334.955-2.42 2.157-2.42 1.21 0 2.176 1.095 2.156 2.42 0 1.335-.946 2.42-2.156 2.42Z" />
    </svg>
  );
}
